
import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "application/features/clientAuth/authClientSlice";
import { useLoginClientMutation, useRegisterClientMutation, useResetPswClientMutation } from "application/features/clientAuth/authClientApiSlice";
import { useTranslation } from "react-i18next";

export interface PageSignUpClientProps {
  className?: string;
  onLogin?: () => void;
}

const PageClientResetPsw: FC<PageSignUpClientProps> = ({ className = "", onLogin }) => {

  const { t, ready } = useTranslation("translation");

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const [resetPsw, { isLoading, isSuccess }] = useResetPswClientMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();


  const handleResetPsw = async (e: any) => {
    e.preventDefault();
    try {
      const resetPswResponse = await resetPsw({ email }).unwrap()
    } catch (error: any) {
      setError("Si è verificato un errore, riprova più tardi")
    }
  }

  if (!ready) return null;

  return (
    <div className={`nc-PageSignUp  ${className}`} data-nc-id="PageSignUp">
      <Helmet>
        <title>{t("translation:userPasswordReset.title")} | TRIBYOU</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <div className="max-w-md mx-auto space-y-6 ">
          {/* FORM */}

          {!isSuccess ?

            <>
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
              {t("translation:userPasswordReset.heading")}
              </h2>
              <form className="grid grid-cols-1 gap-6" onSubmit={handleResetPsw} method="post">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                  {t("translation:userPasswordReset.form.email")}
                  </span>
                  <Input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="address@example.com"
                    className="mt-1"
                  />
                </label>
                {error && <span className="text-red-500">{error}</span>}
                <ButtonPrimary type="submit" loading={isLoading}>{t("translation:userPasswordReset.form.resetButton")}</ButtonPrimary>
              </form>

            </>
            :
            <>
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                {t("translation:userPasswordReset.confirmationSection.heading")}
              </h2>
              <p className="mt-2 text-neutral-800">
                {t("translation:userPasswordReset.confirmationSection.description")}
              </p>
            </>
          }

        </div>
      </div>
    </div>
  );
};

export default PageClientResetPsw;
